<template>
  <a-icon :component="RightArrowIcon" />
</template>

<script>
const RightArrowIcon = {
  template: `
    <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2194 0.968387C12.2891 0.898542 12.3719 0.843128 12.463 0.805318C12.5541 0.767508 12.6518 0.748047 12.7504 0.748047C12.8491 0.748047 12.9468 0.767508 13.0379 0.805318C13.129 0.843128 13.2118 0.898542 13.2814 0.968387L17.7814 5.46839C17.8513 5.53805 17.9067 5.62082 17.9445 5.71194C17.9823 5.80305 18.0018 5.90074 18.0018 5.99939C18.0018 6.09804 17.9823 6.19572 17.9445 6.28684C17.9067 6.37795 17.8513 6.46072 17.7814 6.53039L13.2814 11.0304C13.1406 11.1712 12.9496 11.2503 12.7504 11.2503C12.5513 11.2503 12.3603 11.1712 12.2194 11.0304C12.0786 10.8896 11.9995 10.6985 11.9995 10.4994C11.9995 10.3002 12.0786 10.1092 12.2194 9.96839L16.1899 5.99939L12.2194 2.03039C12.1496 1.96072 12.0942 1.87796 12.0564 1.78684C12.0186 1.69572 11.9991 1.59804 11.9991 1.49939C11.9991 1.40074 12.0186 1.30305 12.0564 1.21194C12.0942 1.12082 12.1496 1.03806 12.2194 0.968387Z" fill="#333333"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 5.80109 0.0790178 5.61032 0.21967 5.46967C0.360322 5.32902 0.551088 5.25 0.75 5.25H16.5C16.6989 5.25 16.8897 5.32902 17.0303 5.46967C17.171 5.61032 17.25 5.80109 17.25 6C17.25 6.19891 17.171 6.38968 17.0303 6.53033C16.8897 6.67098 16.6989 6.75 16.5 6.75H0.75C0.551088 6.75 0.360322 6.67098 0.21967 6.53033C0.0790178 6.38968 0 6.19891 0 6Z" fill="#333333"/>
    </svg>
  `
};

export default {
  data() {
    return {
      RightArrowIcon
    };
  }
};
</script>

<style></style>
